import {
    KPI_MATRIX_LIST,
    KPI_MATRIX_LIST_SUCCESS,
    KPI_MATRIX_LIST_ERROR,
    KPI_MATRIX_LIST_ITB,
    KPI_MATRIX_LIST_ITB_SUCCESS,
    KPI_MATRIX_LIST_ITB_ERROR,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS,
    KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR,
    KPI_MATRIX_VIEW_MODAL_SET,
    KPI_MATRIX_DETAIL,
    KPI_MATRIX_DETAIL_SUCCESS,
    KPI_MATRIX_DETAIL_ERROR,
    KPI_MATRIX_DATA_LIST,
    KPI_MATRIX_DATA_LIST_SUCCESS,
    KPI_MATRIX_DATA_LIST_ERROR,
    KPI_MATRIX_TAB_SET,
    KPI_MATRIX_GRAPH_3MORE_LIST,
    KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_3MORE_LIST_ERROR,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR,
    KPI_MATRIX_GRAPH_PIE_LIST,
    KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_PIE_LIST_ERROR,
    KPI_MATRIX_GRAPH_BAR_LIST,
    KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS,
    KPI_MATRIX_GRAPH_BAR_LIST_ERROR,
    KPI_MATRIX_TAG_SAVINGS_LIST,
    KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS,
    KPI_MATRIX_TAG_SAVINGS_LIST_ERROR,
    KPI_MATRIX_TOTAL_PZS_LIST,
    KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS,
    KPI_MATRIX_TOTAL_PZS_LIST_ERROR,
    KPI_MATRIX_BIDDER_LIST,
    KPI_MATRIX_BIDDER_LIST_SUCCESS,
    KPI_MATRIX_BIDDER_LIST_ERROR,
    KPI_MATRIX_BIDDERMC_LIST,
    KPI_MATRIX_BIDDERMC_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMC_LIST_ERROR,
    KPI_MATRIX_BIDDERMED2021_LIST,
    KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMED2021_LIST_ERROR,
    KPI_MATRIX_BIDDERMC2021_LIST,
    KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS,
    KPI_MATRIX_BIDDERMC2021_LIST_ERROR,
    KPI_FUNNEL_LIST,
    KPI_FUNNEL_LIST_SUCCESS,
    KPI_FUNNEL_LIST_ERROR,
    KPI_FUNNELMC_LIST,
    KPI_FUNNELMC_LIST_SUCCESS,
    KPI_FUNNELMC_LIST_ERROR,

    KPI_EVALUATIONS,
    KPI_EVALUATIONS_SUCCESS,
    KPI_EVALUATIONS_ERROR,
    KPI_EVALUATIONS_SEARCH_SET,
    KPI_EVALUATIONS_SEARCH_CHANGE,
    KPI_EVALUATIONS_TAB_SET,
    KPI_FUNNEL_PROCCESS_LIST,
    KPI_FUNNEL_PROCCESS_LIST_SUCCESS,
    KPI_FUNNEL_PROCCESS_LIST_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    tab: '1',
    list: {
        header: {
            name: 'idkpi',
            order: 'sorted-asc'
        },
        page: {
            current: 1,
            rows: 20
        }
    },
    view: {
        loading: true,
        data: [],
        modal: false,
        log: {
            data: [],
            loading: false,
        },
    },
    viewtab: {
        tab: '1',
        modal: false
    },
    listitb: {
        header: {
            name: 'idkpi',
            order: 'sorted-asc'
        },
        data: [],
        loading: true,
    },
    listanualbaseline: {
        header: {
            name: 'idkpi',
            order: 'sorted-asc'
        },
        data: [],
        loading: true,
    },
    listgraph3more: {
        data: [],
        loading: true,
    },
    listgraphbidderclaves: {
        data: [],
        loadingbidder: true,
    },
    listgraphpie: {
        data: [],
        loadingpie: true,
    },
    listgraphbar: {
        data: [],
        loadingbar: true,
    },
    listtagsavings: {
        data: [],
        loadingtagsavings: true,
    },
    listtotalpzs: {
        data: [],
        loadingtotalpzs: true,
    },
    listbidder: {
        data: [],
        loadingbidder: true,
    },
    listbiddermc: {
        data: [],
        loadingbiddermc: true,
    },
    listbiddermed2021: {
        data: [],
        loadingbiddermed2021: true,
    },
    listbiddermc2021: {
        data: [],
        loadingbiddermc2021: true,
    },
    listfunnel: {
        data: [],
        loadingfunnel: true,
    },
    listfunnelMc: {
        data: [],
        loadingfunnelMc: true,
    },
    detail: {
        data: [],
        loading: true,
    },
    listdata: {
        data: [],
        loading: true,
    },
    funnelproccess: {
        data: [],
        loading: true,
    },
    error: false,
        search: {
        modal: false,
        init: true,
        data: {
            proccesscode: '',
            country: '',
            proccesscodefunnel: '',
            countryfunnel: ''
        },
        value: {
            proccesscodefunnel: '',
            countryfunnel: ''
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case KPI_MATRIX_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case KPI_MATRIX_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case KPI_MATRIX_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_LIST_ITB:
            return {
                ...state,
                loading: true,
                listitb: {
                    ...state.listitb
                }
            }
        case KPI_MATRIX_LIST_ITB_SUCCESS:
            return {
                ...state,
                loading: false,
                listitb: {
                    ...state.listitb,
                    ...action.payload
                }
            }
        case KPI_MATRIX_LIST_ITB_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_LIST_ANUAL_BASE_LINE:
            return {
                ...state,
                loading: true,
                listanualbaseline: {
                    ...state.listanualbaseline
                }
            }
        case KPI_MATRIX_LIST_ANUAL_BASE_LINE_SUCCESS:
            return {
                ...state,
                loading: false,
                listanualbaseline: {
                    ...state.listanualbaseline,
                    ...action.payload
                }
            }
        case KPI_MATRIX_LIST_ANUAL_BASE_LINE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_VIEW_MODAL_SET:
            return {
                ...state,
                view: {
                    ...state.view,
                    modal: action.payload
                }
            }
        case KPI_MATRIX_DETAIL:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: true,
                    data: []
                }
            }
        case KPI_MATRIX_DETAIL_SUCCESS:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: false,
                    data: action.payload
                }
            }
        case KPI_MATRIX_DETAIL_ERROR:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    loading: false,
                    data: []
                }
            }
        case KPI_MATRIX_DATA_LIST:
            return {
                ...state,
                loading: true,
                listdata: {
                    ...state.listdata
                }
            }
        case KPI_MATRIX_DATA_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: {
                    ...state.listdata,
                    ...action.payload
                }
            }
        case KPI_MATRIX_DATA_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_GRAPH_3MORE_LIST:
            return {
                ...state,
                loading: true,
                listgraph3more: {
                    ...state.listgraph3more
                }
            }
        case KPI_MATRIX_GRAPH_3MORE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listgraph3more: {
                    ...state.listgraph3more,
                    ...action.payload
                }
            }
        case KPI_MATRIX_GRAPH_3MORE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST:
            return {
                ...state,
                loadingbidder: true,
                listgraphbidderclaves: {
                    ...state.listgraphbidderclaves
                }
            }
        case KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_SUCCESS:
            return {
                ...state,
                loadingbidder: false,
                listgraphbidderclaves: {
                    ...state.listgraphbidderclaves,
                    ...action.payload
                }
            }
        case KPI_MATRIX_GRAPH_BIDDER_CLAVES_LIST_ERROR:
            return {
                ...state,
                loadingbidder: false,
                error: true
            }
        case KPI_MATRIX_GRAPH_PIE_LIST:
            return {
                ...state,
                loading: true,
                listgraphpie: {
                    ...state.listgraphpie
                }
            }
        case KPI_MATRIX_GRAPH_PIE_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listgraphpie: {
                    ...state.listgraphpie,
                    ...action.payload
                }
            }
        case KPI_MATRIX_GRAPH_PIE_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_GRAPH_BAR_LIST:
            return {
                ...state,
                loading: true,
                listgraphbar: {
                    ...state.listgraphbar
                }
            }
        case KPI_MATRIX_GRAPH_BAR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                listgraphbar: {
                    ...state.listgraphbar,
                    ...action.payload
                }
            }
        case KPI_MATRIX_GRAPH_BAR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case KPI_MATRIX_TAG_SAVINGS_LIST:
            return {
                ...state,
                loadingtagsavings: true,
                listtagsavings: {
                    ...state.listtagsavings
                }
            }
        case KPI_MATRIX_TAG_SAVINGS_LIST_SUCCESS:
            return {
                ...state,
                loadingtagsavings: false,
                listtagsavings: {
                    ...state.listtagsavings,
                    ...action.payload
                }
            }
        case KPI_MATRIX_TAG_SAVINGS_LIST_ERROR:
            return {
                ...state,
                loadingtagsavings: false,
                error: true
            }
        case KPI_MATRIX_TOTAL_PZS_LIST:
            return {
                ...state,
                loadingtotalpzs: true,
                listtotalpzs: {
                    ...state.listtotalpzs
                }
            }
        case KPI_MATRIX_TOTAL_PZS_LIST_SUCCESS:
            return {
                ...state,
                loadingtotalpzs: false,
                listtotalpzs: {
                    ...state.listtotalpzs,
                    ...action.payload
                }
            }
        case KPI_MATRIX_TOTAL_PZS_LIST_ERROR:
            return {
                ...state,
                loadingtotalpzs: false,
                error: true
            }
        case KPI_MATRIX_BIDDER_LIST:
            return {
                ...state,
                loadingbidder: true,
                listbidder: {
                    ...state.listbidder
                }
            }
        case KPI_MATRIX_BIDDER_LIST_SUCCESS:
            return {
                ...state,
                loadingbidder: false,
                listbidder: {
                    ...state.listbidder,
                    ...action.payload
                }
            }
        case KPI_MATRIX_BIDDER_LIST_ERROR:
            return {
                ...state,
                loadingbidder: false,
                error: true
            }
        case KPI_MATRIX_BIDDERMC_LIST:
            return {
                ...state,
                loadingbiddermc: true,
                listbiddermc: {
                    ...state.listbiddermc
                }
            }
        case KPI_MATRIX_BIDDERMC_LIST_SUCCESS:
            return {
                ...state,
                loadingbiddermc: false,
                listbiddermc: {
                    ...state.listbiddermc,
                    ...action.payload
                }
            }
        case KPI_MATRIX_BIDDERMC_LIST_ERROR:
            return {
                ...state,
                loadingbiddermc: false,
                error: true
            }
        case KPI_MATRIX_BIDDERMED2021_LIST:
            return {
                ...state,
                loadingbiddermed2021: true,
                listbiddermed2021: {
                    ...state.listbiddermed2021
                }
            }
        case KPI_MATRIX_BIDDERMED2021_LIST_SUCCESS:
            return {
                ...state,
                loadingbiddermed2021: false,
                listbiddermed2021: {
                    ...state.listbiddermed2021,
                    ...action.payload
                }
            }
        case KPI_MATRIX_BIDDERMED2021_LIST_ERROR:
            return {
                ...state,
                loadingbiddermed2021: false,
                error: true
            }
        case KPI_MATRIX_BIDDERMC2021_LIST:
            return {
                ...state,
                loadingbiddermc2021: true,
                listbiddermc2021: {
                    ...state.listbiddermc2021
                }
            }
        case KPI_MATRIX_BIDDERMC2021_LIST_SUCCESS:
            return {
                ...state,
                loadingbiddermc2021: false,
                listbiddermc2021: {
                    ...state.listbiddermc2021,
                    ...action.payload
                }
            }
        case KPI_MATRIX_BIDDERMC2021_LIST_ERROR:
            return {
                ...state,
                loadingbiddermc2021: false,
                error: true
            }
        case KPI_FUNNEL_LIST:
            return {
                ...state,
                loadingfunnel: true,
                listfunnel: {
                    ...state.listfunnel
                }
            }
        case KPI_FUNNEL_LIST_SUCCESS:
            return {
                ...state,
                loadingfunnel: false,
                listfunnel: {
                    ...state.listbfunnel,
                    ...action.payload
                }
            }
        case KPI_FUNNEL_LIST_ERROR:
            return {
                ...state,
                loadingfunnel: false,
                error: true
            }
        case KPI_FUNNELMC_LIST:
            return {
                ...state,
                loadingfunnelMc: true,
                listfunnelMc: {
                    ...state.listfunnelMc
                }
            }
        case KPI_FUNNELMC_LIST_SUCCESS:
            return {
                ...state,
                loadingfunnelMc: false,
                listfunnelMc: {
                    ...state.listbfunnelMc,
                    ...action.payload
                }
            }
        case KPI_FUNNELMC_LIST_ERROR:
            return {
                ...state,
                loadingfunnelMc: false,
                error: true
            }
        case KPI_MATRIX_TAB_SET:
            return {
                ...state,
                    tab: action.payload
            }

        case KPI_EVALUATIONS_SEARCH_SET:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case KPI_EVALUATIONS_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    value: action.payload,
                }
            }

        case KPI_EVALUATIONS:
            return {
                ...state,
                loadingfunnel: true,
                listfunnel: {
                    ...state.listfunnel
                }
            }
        case KPI_EVALUATIONS_SUCCESS:
            return {
                ...state,
                loadingfunnel: false,
                listfunnel: {
                    ...state.listbfunnel,
                    ...action.payload
                }
            }
        case KPI_EVALUATIONS_ERROR:
            return {
                ...state,
                loadingfunnel: false,
                error: true
            }
        case KPI_EVALUATIONS_TAB_SET:
            return {
                ...state,
                viewtab: {
                    ...state.viewtab,
                    tab: action.payload
                }
            }
        case KPI_FUNNEL_PROCCESS_LIST:
            return {
                ...state,
                loading: true,
                funnelproccess: {
                    ...state.funnelproccess
                }
            }
        case KPI_FUNNEL_PROCCESS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                funnelproccess: {
                    ...state.funnelproccess,
                    ...action.payload
                }
            }
        case KPI_FUNNEL_PROCCESS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};